import React from 'react'
import { Button } from 'react-bootstrap'
import { Star, StarFill } from 'react-bootstrap-icons'

const FiveStar = ({
    value = '0',
    onChange = () => {}
}) => {
    const buttons = [1, 2, 3, 4, 5]

    const buttonStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '20px',
        fontSize: '1em',
        textAlign: 'center',
    }

    const renderButton = (button, key) => {
        const Icon = parseInt(value) < button ? Star : StarFill
        return (
            <div style={{ padding: '5px'}} key={key}>
                <Button
                    variant='link'
                    onClick={() => onChange(button.toString())}
                >
                    <Icon size={30} />
                </Button>
            </div>
        )
    }

    return (
        <div style={{ display: 'flex'}}>
            {buttons.map(renderButton)}
        </div>
    )
}

export default FiveStar
